var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.38619 14C1.15592 13.9996 0.929722 13.9383 0.729852 13.8223C0.279789 13.5636 0 13.0615 0 12.5163V1.48376C0 0.937074 0.279789 0.436424 0.729852 0.177729C0.934481 0.0584393 1.16694 -0.00290576 1.40294 0.000105775C1.63894 0.00311731 1.86981 0.0703751 2.07141 0.194849L11.3671 5.83895C11.5608 5.96217 11.7205 6.13328 11.8312 6.33623C11.9419 6.53918 12 6.76733 12 6.99927C12 7.23122 11.9419 7.45936 11.8312 7.66232C11.7205 7.86527 11.5608 8.03638 11.3671 8.15959L2.06991 13.8052C1.8636 13.9317 1.62728 13.9991 1.38619 14V14Z","fill":"white"}));
}

Play.defaultProps = {"width":"12","height":"14","viewBox":"0 0 12 14","fill":"none"};

module.exports = Play;

Play.default = Play;
